import React, { useEffect, lazy } from 'react';
import { useParams } from 'react-router-dom';
import { getSignById } from '../data/signs';
import { BackButton } from '../components/layout/BackButton';
import { SignHero } from '../components/sign/SignHero';
import { SignPreviewNote } from '../components/sign/SignPreviewNote';
import { VistaDelNucleo } from '../components/sign/VistaDelNucleo';
import { SignPatron } from '../components/sign/SignPatron';
import { SignProblema } from '../components/sign/SignProblema';
import { SignCambioPerspectiva } from '../components/sign/SignCambioPerspectiva';
import { SignSolucion } from '../components/sign/SignSolucion';
import { SignDescubrir } from '../components/sign/SignDescubrir';
import { SignDesbloqueo } from '../components/sign/SignDesbloqueo';
import { SignParaQuien } from '../components/sign/SignParaQuien';
import { SignProductos } from '../components/sign/SignProductos';
import { SignReviews } from '../components/sign/SignReviews';
import { SignCTA } from '../components/sign/SignCTA';
import { FAQ } from '../components/home/FAQ';
const PROBLEMA_SOLUCION_BG = 'https://cdn.shopify.com/s/files/1/0661/3847/2542/files/Wo_P7B_zdv8m9RvhXj7oHsrVCD8DHmoaCV8LM93AvU4jwAaKiGqzNwGb4XYEagB9_tZ0TcHraHRe_tnjw_TqjyQZxuHl5rbrSK5lMOirgN3ahHy_2wo6yUvf1xmSggU58NRTNKzMv.jpg?v=1778629047';
export function SignPage() {
  const {
    signId
  } = useParams<{
    signId: string;
  }>();
  const sign = signId ? getSignById(signId) : null;
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto'
    });
  }, [signId]);
  if (!sign) {
    return <div className="min-h-screen flex items-center justify-center bg-cosmic-black" data-id="element-1197">
        <p className="text-white text-xl" data-id="element-1198">Signo no encontrado</p>
      </div>;
  }
  return <div className="w-full bg-cosmic-black" data-id="element-1199">
      <BackButton signColor={sign.colors.primary} data-id="element-1200" />
      <SignHero sign={sign} data-id="element-1201" />

      <SignPreviewNote sign={sign} data-id="element-1202" />
      <VistaDelNucleo sign={sign} data-id="element-1203" />

      <SignPatron sign={sign} data-id="element-1204" />

      {/* Combined background for SignProblema + SignCambioPerspectiva + SignSolucion, tinted with sign color */}
      <div className="relative" data-id="element-1205">
        <div className="absolute inset-0 z-0" data-id="element-1206">
          <img src={PROBLEMA_SOLUCION_BG} alt="" aria-hidden="true" className="w-full h-full object-cover" loading="lazy" data-id="element-1207" />
          <div className="absolute inset-0 bg-cosmic-black/75" data-id="element-1208" />
          <div className="absolute inset-0" style={{
          backgroundColor: sign.colors.primary,
          opacity: 0.18
        }} data-id="element-1209" />
          <div className="absolute inset-0" style={{
          background: `linear-gradient(180deg, #050508 0%, ${sign.colors.primary}15 50%, #050508 100%)`
        }} data-id="element-1210" />
        </div>
        <div className="relative z-10" data-id="element-1211">
          <SignProblema sign={sign} data-id="element-1212" />
          <SignCambioPerspectiva sign={sign} data-id="element-1213" />
          <SignSolucion sign={sign} data-id="element-1214" />
        </div>
      </div>

      <SignDescubrir sign={sign} data-id="element-1215" />

      <SignDesbloqueo sign={sign} data-id="element-1216" />
      <SignParaQuien sign={sign} data-id="element-1217" />

      <SignProductos sign={sign} data-id="element-1218" />
      <SignReviews sign={sign} data-id="element-1219" />
      <FAQ data-id="element-1220" />
      <SignCTA sign={sign} data-id="element-1221" />
    </div>;
}